'use client';

import useStore from '@/stores/useStore';
import "@/styles/libs/arrow-animation.css";
import { FC } from 'react';

export interface AddOnsProps {
  addOnFeatures: {
    title: string;
    description: string;
    price: string;
    metaPricing: string;
    priceDescription: string;
    plansIncluded: string;
  }[];
}

const AddOns: FC<AddOnsProps> = ({
  addOnFeatures = []
}) => {

  const { setDemoModalOpen, setTrialModalOpen } = useStore();

  const onClickMenuButton = (action) => {
    switch (action) {
      case 'trial':
        setTrialModalOpen(true);
        break;
      case 'demo':
        setDemoModalOpen(true);
        break;

      default:
        break;
    }
  };

  return (
    <section className="flex py-[80px] md:py-[120px] px-[24px] bg-gray-100">
      <div className="w-full mx-auto max-w-grid flex flex-wrap justify-center md:grid grid-cols-3 gap-x-2 rounded-12">
        <div className="col-span-full text-gray-700 text-micro3 text-center uppercase">
          add-ons
        </div>
        <div className="col-span-full text-center text-blue-900 font-500 text-h1 my-[12px]">
          More ways to extend the power of Front
        </div>
        <div className="col-span-full text-center text-gray-700 text-p2 mb-[80px]">
          Get even more value out of Front with add-ons that help you deliver exceptional support at scale
        </div>

        {addOnFeatures.map((feature, index) => (
          <div key={`add-on-feature-${index}`} className={`flex flex-wrap bg-white rounded-[12px] p-[32px] items-start mb-[24px] md:mb-0 ${index === 0 ? "border-solid border-[8px] border-[#D3B4F4] mt-[-8px]" : ""}`}>
            <div className="flex w-full flex-wrap items-start">
              <div className="flex w-full items-center text-blue-900 font-500 text-h4 mb-[8px]">
                {feature.title}
                {index === 0 && (
                  <span className="bg-citron-500 uppercase text-caption2 text-blue-950 rounded-[4px] px-[8px] py-[2px] ml-[8px]">popular</span>
                )}
              </div>
              <div className="flex w-full text-blue-900 text-caption1">
                {feature.description}
              </div>
            </div>
            <div className="flex w-full flex-wrap items-end mt-[48px]">
              <div className="flex w-full flex-wrap text-blue-900 text-caption1">
                {feature.metaPricing && (
                  <div className="text-blue-900 w-full font-500 text-caption1">
                    {feature.metaPricing}
                  </div>
                )}
                <span>
                  <span className="text-blue-900 w-full font-500 text-h4">{feature.price}</span> {feature.priceDescription}
                </span>
                <div className="flex font-500 text-gray-700 text-caption1">
                  {feature.plansIncluded}
                </div>
              </div>
              <button
                className="flex font-500 text-blue-900 text-p2 items-center mt-[18px] hover-arrow-wrapper"
                onClick={() => {
                  onClickMenuButton("demo");
                }}
              >
                <span>Talk to Sales</span>
                <div className="flex ml-[8px] relative w-[16px] h-[16px] bg-[url(https://front.com/webassets/rebrand/black-right-arrow.png)] hover-arrow" />
              </button>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default AddOns;
